<template>

    <div class="stepper-controls">
        <div class="stepper-controls__progress-bar" :style="progressBarStyle"></div>
        <button class="stepper-controls__element"
                :class="index === currentStep ? 'stepper-controls__element--active' : ''"
                @click.prevent="() => clickElement(index)" 
                :disabled="!elementIsClickable(index)"
                :key="'step-' + index"
                v-for="(step,index) in steps" 
        >
            <div class="stepper-controls__bubble">
                {{index + 1}}
            </div>
            <div class="stepper-controls__bubble stepper-controls__bubble--active" v-if="index<=currentStep">
                <img src="/images/icons/edit.svg" alt="Edit Symbol">
            </div>
            <div class="stepper-controls__bubble stepper-controls__bubble--visited"  v-if="index<currentStep">
                <img src="/images/icons/success.svg" alt="Edit Symbol">
            </div>
            <div class="stepper-controls__title">
                {{step}} 
            </div>
        </button>
    </div>
</template>

<script>
import { EventBus } from '../eventbus.js';

export default {
    props: {
        steps: {
            type: Array,
            required: true,
            validator: (steps) => {
                // Array must contain at least 2 values, all values must be strings
                return steps.length > 1 && steps.every((value) => typeof value === "string");
            }
        },
        initialStep:    {
            type: Number,
            default: 0
        },
        clickable: Boolean
    },
    data() {
        return {
            currentStep: this.initialStep
        }
    },
    computed: {
        /**
         * With 4 Elements:
         *   Step 0 is considered 0% (done with css min width of bar)
         *   Step 1 is oncisdered 33.3333%
         *   Step 2 is oncisdered 66.6666%
         *   Step 3 is oncisdered 100% (done with css, max width of bar)
         * 
         * With 3 Elements
         *   Step 0 = 0%
         *   Step 1 = 50%
         *   Step 3 = 100%
         * 
         * This does not exactly add up but is good enough for our usecase
         */
        progressPrecent() {
            if (this.currentStep === 0) {
                return 0;
            }
            if (this.currentStep === this.steps.length-1) {
                return 100;
            }
            return ((this.currentStep) / (this.steps.length -1)) * 100;
        },
        progressBarStyle() {    
            return {
                width: `${this.progressPrecent}%`
            }
        }
    },
    methods: {
        clickElement(index) {
            if(this.elementIsClickable(index)) {
                this.changeStepTo(index)
            }
        },
        changeStepTo(number) {
            EventBus.$emit('changeStepperTo', number);
        },
        elementIsClickable(index) {
            return this.clickable && this.currentStep > index;
        }
    },
    mounted() {
        EventBus.$on('changeStepperTo', stepId => {
            this.currentStep = stepId;
        });
    },
}
</script>
